import PropTypes from "prop-types";
import AnimatedList from "../AnimatedList";
import useSortChanged from "./useSortChanged";

const ProductTileList = ({ sort, sortOrder, children }) => {
  const sortChanged = useSortChanged({ sort, sortOrder });

  return <AnimatedList disableAnimation={sortChanged}>{children}</AnimatedList>;
};

ProductTileList.propTypes = {
  sort: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
};

export default ProductTileList;
